<div class="container-fluid p-0">
  <div class="mx-0 mt-1 fade-in compensate-for-scrollbar text-right">
    <div class="ml-0 mt-5 mr-4 w-75 text-left">
      <h1 class="display-3 ml-0" style="color: #171717; font-family: 'Montserrat', sans-serif; font-weight: bold">Skopje</h1>
      <h1 class="display-5 mt-0 ml-0" style="color:  #171717;font-family: 'Montserrat', sans-serif; font-weight: lighter">Photo Exhibit</h1>
      <h1 class="header-info-italic mt-4 ml-0" style="color: #171717; font-family: 'Montserrat', sans-serif">Exhibit
        of 30 curated photos captured in the city of Skopje, portraying the true character of the city.<br>
        The city where its beauty lies in the decaying history and brutal architecture.</h1>
      <h1 class="header-info-italic mt-1 ml-0" style="color: #171717; font-family: 'Montserrat', sans-serif">
        . . .</h1>
      <a href="sk.html" class="display-4 hyperlink my-0"  style="font-family: 'Montserrat', sans-serif;
                                                                      font-style: italic;
                                                                      text-decoration: none;">[ Enter ]
      </a>
    </div>
  </div>
</div>
